import React, { useContext, useEffect, useState } from 'react';
import TextInput from 'plaid-threads/TextInput';
import { useSearchBox } from 'react-instantsearch';

import Context from 'src/contexts/docs';
import { useDebounce } from 'src/components/docs/utilities';

import styles from 'src/components/docs/Search/SearchInput.module.scss';

interface InputProps {
  currentRefinement?: string;
  refine: (value: string) => void;
}

const Input: React.FC<InputProps> = ({ refine }) => {
  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const debouncedInputValue = useDebounce(inputValue, 200);
  const { dispatch, openSearchClicked } = useContext(Context);

  useEffect(() => {
    document.getElementById('search-input')?.focus();
  }, []);

  useEffect(() => {
    if (openSearchClicked) {
      setIsOpen(true);
    }

    if (inputValue && inputValue === '/' && !isOpen) {
      setInputValue('');
      setIsOpen(true);
      return;
    }
  }, [inputValue, isOpen, openSearchClicked]);

  useEffect(() => {
    // Clear search when input is empty or shorter than the minimum query length
    if (!debouncedInputValue || debouncedInputValue.length < 3) {
      refine('');
      return;
    }

    refine(debouncedInputValue);

    dispatch({
      type: 'DOCS_SEARCH_INPUT',
      payload: { searchQuery: debouncedInputValue },
    });
  }, [debouncedInputValue, dispatch, refine]);

  return (
    <div className={styles.searchInput}>
      <TextInput
        autoComplete='off'
        className={styles.input}
        id='search-input'
        label='Search Core Exchange Docs'
        placeholder='Search Core Exchange Docs'
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
    </div>
  );
};

function connectSearchBox(Component: React.FC<InputProps>) {
  const SearchBox: React.FC = () => {
    const data = useSearchBox();
    return <Component {...data} />;
  };
  SearchBox.displayName = 'CoreExchangeSearchInput';
  return SearchBox;
}

const SearchInput = connectSearchBox(Input);

export default SearchInput;
